import { render, staticRenderFns } from "./successforgot.vue?vue&type=template&id=122a65af"
import script from "./successforgot.vue?vue&type=script&lang=js"
export * from "./successforgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports